module.exports = __webpack_public_path__ + "img/snowy-4.474b6da7.svg";